module.exports = __webpack_public_path__ + "img/logo-w.de546761.png";